export default {
  actions: (actions) => actions,
  nav: (routes) => routes,
  admin: (routes) => routes,
};
